// extracted by mini-css-extract-plugin
module.exports = {"container":"richTextComponent_container__YSk9N","rich-text-content":"richTextComponent_rich-text-content__ZUlmD","richTextContent":"richTextComponent_rich-text-content__ZUlmD"};